import React from 'react';
import moment from 'moment';
import styled from 'styled-components';
import { ArrowBack, SaveAltOutlined } from '@material-ui/icons';
import { STATUS_LABELS } from '../utils/status';
import { BORDER, GREY_TEXT } from '../AnalyticsV2.styled';
import DateRange from '../components/Toolbar/DateRange';
import StatusCell from '../components/MessageTable/StatusCell';
import RowMenu from '../components/MessageTable/RowMenu';
import { LinkButton, OutlinedButton } from './MessageDetail.styled';
import ResendStatus from './ResendStatus';

const TopRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 24px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const TitleRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 20px;
`;

const Title = styled.h1`
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 0;
  font-size: 26px;
  font-weight: 500;
  color: #1c1c1c;
`;

const ABChip = styled.span`
  padding: 2px 10px;
  border: 1px solid ${BORDER};
  border-radius: 12px;
  font-size: 13px;
  font-weight: 500;
  color: ${GREY_TEXT};
  background: #f4f5f7;
`;

// The subject on the left, the resend line on the right under the facts.
const SubjectRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin-top: 6px;
`;

const Subject = styled.div`
  font-size: 15px;
  color: #1c1c1c;
`;

const Facts = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  font-size: 14px;
  color: ${GREY_TEXT};
  white-space: nowrap;
  b {
    font-weight: 500;
    color: #1c1c1c;
  }
`;

const Status = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
`;

// Back link, draft name, A/B chip, subject, the graph's date range, Export
// CSV, send date, status, the row menu and the resend line.
const Header = ({
  message,
  dateRange,
  onDateRangeChange,
  disabledDate,
  onCalendarChange,
  onOpenChange,
  onBack,
  onExport,
  onChanged,
}) => (
  <>
    <TopRow>
      <LinkButton onClick={onBack}>
        <ArrowBack /> Back to Messages
      </LinkButton>
      <Actions>
        <DateRange
          value={dateRange}
          onChange={onDateRangeChange}
          disabledDate={disabledDate}
          onCalendarChange={onCalendarChange}
          onOpenChange={onOpenChange}
        />
        <OutlinedButton onClick={onExport}>
          <SaveAltOutlined fontSize="small" /> Export CSV
        </OutlinedButton>
      </Actions>
    </TopRow>
    <TitleRow>
      <Title>
        {message.draftName}
        {message.AB?.linkedMessageId && <ABChip>A/B</ABChip>}
      </Title>
      <Facts>
        <span>
          Send Date:{' '}
          <b>{moment.unix(message.sendTime).format('MMM Do YYYY')}</b>
        </span>
        <Status>
          Status: <StatusCell message={message} />
          <b>{STATUS_LABELS[message.status]}</b>
        </Status>
        <RowMenu message={message} onChanged={onChanged} />
      </Facts>
    </TitleRow>
    <SubjectRow>
      <Subject>{message.messageSubject}</Subject>
      <ResendStatus message={message} onChanged={onChanged} />
    </SubjectRow>
  </>
);

export default Header;
